export default __webpack_public_path__ + "erasure.mp3";